import cn from 'classnames';

const BestFitLabel = ({ className }) => {
  return (
    <span
      className={cn(
        'h7 absolute bottom-14 right-0 w-16 rounded-2xl border border-solid text-charcoal-100',
        className
      )}
    >
      Best Fit
    </span>
  );
};

BestFitLabel.propTypes = {
  className: PropTypes.string,
};

export default BestFitLabel;
